/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { omit } from 'lodash';

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import ChoiceButtons from 'shared/ui/components/form-components/ChoiceButtons.vue';
import HybridHelperBlock from 'ui/components/live-session/HybridHelperBlock.vue';

const __vue_script__ = {
    name: 'TypesOptions',

    components: { BaseSelect, ChoiceButtons, HybridHelperBlock },

    props: {
        value: {
            type: Object,
            default: () => ({})
        },

        form: {
            type: Object,
            default: () => ({})
        },

        focused: {
            type: String,
            default: null
        },

        keep: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            innerValue: {},
            eventFormats: [{
                value: 'virtual',
                label: 'event_formats.virtual'
            }, {
                value: 'in_person',
                label: 'event_formats.in_person'
            }, {
                value: 'hybrid',
                label: 'event_formats.hybrid'
            }],

            audienceTypes: [{
                value: 'internal',
                label: 'audience_types.internal'
            }, {
                value: 'external',
                label: 'audience_types.external'
            }, {
                value: 'mixed',
                label: 'audience_types.mixed'
            }],

            eventScopes: [{
                value: 'global',
                label: 'event_scopes.global',
                icon: 'ic-earth'
            }, {
                value: 'regional',
                label: 'event_scopes.regional',
                icon: 'ic-building'
            }, {
                value: 'local',
                label: 'event_scopes.local',
                icon: 'ic-shop'
            }],

            expectedAttendances: [{
                value: '49',
                label: this.t('expected_attendances.49')
            }, {
                value: '100',
                label: this.t('expected_attendances.100')
            }, {
                value: '500',
                label: this.t('expected_attendances.500')
            }, {
                value: '1000',
                label: this.t('expected_attendances.1000')
            }, {
                value: '2500',
                label: this.t('expected_attendances.2500')
            }, {
                value: '2501',
                label: this.t('expected_attendances.2501')
            }]
        };
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                this.innerValue = {
                    event_format: this.value.event_format,
                    audience_type: this.value.audience_type,
                    event_scope: this.value.event_scope,
                    expected_attendance: this.expectedAttendances.find(a => a.value === this.value?.expected_attendance)
                };
            }
        }
    },

    created() {
        this.emit(); // Emit initial value
    },

    methods: {
        emit() {
            const payload = {
                event_format: this.innerValue.event_format,
                audience_type: this.innerValue.audience_type,
                event_scope: this.innerValue.event_scope,
                expected_attendance: this.innerValue.expected_attendance?.value
            };

            if (this.keep) {
                const extValues = omit(this.value, ...Object.keys(payload));
                Object.assign(payload, extValues);
            }

            this.$emit('input', payload);
        },

        t(key) {
            return this.$i18n.t(`wizards.create_workspace.form.${key}`);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "types-options" },
    [
      _c("legend", [_vm._v(_vm._s(_vm.t("fieldsets.event_specs")))]),
      _c("validation-provider", {
        attrs: { rules: "required", slim: true, name: "event_format" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("choice-buttons", {
                  attrs: {
                    name: "event_format",
                    options: _vm.eventFormats,
                    label: _vm.t("fieldsets.event_format"),
                    errors: errors,
                    disabled: _vm.disabled,
                  },
                  on: { input: _vm.emit },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "choice",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            item.value !== "in_person"
                              ? _c("i", { staticClass: "ic-remote" })
                              : _vm._e(),
                            item.value !== "virtual"
                              ? _c("i", { staticClass: "ic-in-person" })
                              : _vm._e(),
                            _c("span", { staticClass: "text" }, [
                              _vm._v(_vm._s(_vm.t(item.label))),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.innerValue.event_format,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "event_format", $$v)
                    },
                    expression: "innerValue.event_format",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      (_vm.innerValue.event_format || {}) === "hybrid"
        ? _c("hybrid-helper-block")
        : _vm._e(),
      _c("validation-provider", {
        attrs: { rules: "required", slim: true, name: "audience_type" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("choice-buttons", {
                  attrs: {
                    name: "audience_type",
                    options: _vm.audienceTypes,
                    label: _vm.t("fieldsets.audience_type"),
                    tip: _vm.t("fieldsets.audience_type_tip"),
                    errors: errors,
                    disabled: _vm.disabled,
                  },
                  on: { input: _vm.emit },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "choice",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("i", { class: "ic-" + item.value }),
                            _c("span", { staticClass: "text" }, [
                              _vm._v(_vm._s(_vm.t(item.label))),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.innerValue.audience_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "audience_type", $$v)
                    },
                    expression: "innerValue.audience_type",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { rules: "required", slim: true, name: "event_scope" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("choice-buttons", {
                  attrs: {
                    name: "event_scope",
                    options: _vm.eventScopes,
                    label: _vm.t("fieldsets.event_scope"),
                    errors: errors,
                    disabled: _vm.disabled,
                  },
                  on: { input: _vm.emit },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "choice",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("i", { class: item.icon }),
                            _c("span", { staticClass: "text" }, [
                              _vm._v(_vm._s(_vm.t(item.label))),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.innerValue.event_scope,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "event_scope", $$v)
                    },
                    expression: "innerValue.event_scope",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { rules: "required", slim: true, name: "expected_attendance" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("base-select", {
                  attrs: {
                    name: "expected_attendance",
                    "track-by": "value",
                    errors: errors,
                    disabled: _vm.disabled,
                    focused: _vm.focused === "expected_attendance",
                    "allow-empty": false,
                    options: _vm.expectedAttendances,
                    label: _vm.t("fieldsets.expected_attendance"),
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.innerValue.expected_attendance,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "expected_attendance", $$v)
                    },
                    expression: "innerValue.expected_attendance",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._t("default"),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/wizards/create-workspace/TypesOptions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__